module.exports = __webpack_public_path__ + "img/338.c09d4b0c.jpg";